// refactor for only a datalayer push and a hubspot
export default class GoogleTagManagerLogic {
  public static pushEvent(name: string, virtualUrl: string) {
    const { dataLayer } = window as any;
    if (!dataLayer) {
      console.error('GTM not installed');
      return;
    }

    // eslint-disable-next-line no-multi-assign, no-underscore-dangle
    const hsq = ((window as any)._hsq = (window as any)._hsq || []);
    hsq.push(['trackPageView']);

    dataLayer.push({
      event: name,
      virtualUrl,
    });
  }
}
